"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.Card = function (_a) {
    var children = _a.children;
    return react_1.default.createElement(StyledContainer, null, children);
};
var StyledContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  background-color: ", ";\n  border-top: 2px solid ", ";\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);\n  min-width: 34.8rem;\n  min-height: 30.4rem;\n  width: 100%;\n  height: 100%;\n"], ["\n  background-color: ", ";\n  border-top: 2px solid ", ";\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);\n  min-width: 34.8rem;\n  min-height: 30.4rem;\n  width: 100%;\n  height: 100%;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.aqua[700];
});
var templateObject_1;
